import { HelpContent } from "../context/help.context";

export const helpContentMap: { [key: string]: HelpContent } = {
  dashboard: {
    title: "Dashboard Help",
    description:
      "The dashboard provides an overview of all institutes and their configuration status. You can select an institute to work with, view configuration completeness, and access quick links to different configuration domains.",
    indianContext:
      "In the Indian educational system, institutes typically include schools, colleges, and universities that need to be configured according to CBSE, ICSE, or state board requirements. Each institute may have different compliance and academic structure requirements.",
  },
  institute: {
    title: "Institute Configuration Help",
    description:
      "Configure institute details including name, contact information, address, and status. This information is used throughout the system for compliance and reporting purposes.",
    fields: {
      name: {
        label: "Institute Name",
        description:
          "Enter the official name of the institute as registered with the education board.",
        indianContext:
          "This should match the name registered with the education board (CBSE, ICSE, State Board). The name should be in the same format as on official documents.",
      },
      contact: {
        label: "Contact Information",
        description:
          "Provide primary contact details including phone number and email address.",
        indianContext:
          "Ensure contact information matches the details registered with the education board for official communications.",
      },
      address: {
        label: "Address",
        description:
          "Enter the complete address of the institute including street, city, state, and PIN code.",
        indianContext:
          "Address must include PIN code (6-digit postal code) as required by Indian postal standards. State and district information is important for state board compliance.",
      },
    },
    indianContext:
      "Institute configuration must comply with Indian education board requirements (CBSE, ICSE, State Boards). Ensure all information matches official registration documents.",
  },
  spocPremise: {
    title: "SPOC & Premise Management Help",
    description:
      "Manage Single Point of Contact (SPOC) personnel and premises for each institute. SPOCs are responsible for coordination and communication.",
    indianContext:
      "SPOC designation is important for compliance with Indian education board requirements. Each premise must have a designated SPOC for official communications.",
  },
  compliance: {
    title: "Compliance Management Help",
    description:
      "Configure compliance requirements and track compliance status for institutes. This includes regulatory requirements and certifications.",
    indianContext:
      "Compliance requirements vary by education board (CBSE, ICSE, State Boards) and may include UGC, AICTE, or state-specific regulations. Ensure all required certifications are documented.",
  },
  feeStructure: {
    title: "Fee Structure Configuration Help",
    description:
      "Configure fee categories, pricing rules, and fee schedules for the institute. This includes tuition fees, examination fees, and other charges.",
    indianContext:
      "Fee structures must comply with fee regulations set by education boards and state governments. Fee categories may include tuition, examination, library, laboratory, and other charges as per board requirements.",
  },
  academic: {
    title: "Academic Structure Help",
    description:
      "Configure academic structure including courses, classes, grade levels, and syllabus. This defines the educational framework for the institute.",
    indianContext:
      "Academic structure must align with the education board curriculum (CBSE, ICSE, State Boards). Grade levels, courses, and syllabus should match board-prescribed standards.",
  },
  assessment: {
    title: "Assessment Help",
    description:
      "Create class assessments (exams, assignments, etc.), and configure scoring structures, grade criteria, and evaluation methods.",
    indianContext:
      "Assessment design should comply with board evaluation systems (for example CBSE CCE). Weighting and grading rules vary by board.",
  },
  branding: {
    title: "Branding Configuration Help",
    description:
      "Configure branding elements including logos, colors, and visual identity for the institute's digital presence.",
  },
  localization: {
    title: "Localization Help",
    description:
      "Configure language settings and regional preferences for the institute's interface and communications.",
    indianContext:
      "Support for multiple Indian languages (Hindi, regional languages) may be required based on state and board requirements.",
  },
  rbac: {
    title: "Roles Help",
    description:
      "Manage Role-Based Access Control (RBAC) matrix to define permissions for different user roles within the system.",
    indianContext:
      "RBAC should align with typical Indian educational institution hierarchies: Principal, Vice Principal, Admin, Teachers, and support staff with appropriate access levels.",
  },
  auditTrail: {
    title: "Audit Trail Help",
    description:
      "View audit trail of all system activities including user actions, configuration changes, and system events for compliance and tracking purposes.",
    indianContext:
      "Audit trails are important for compliance with education board requirements and for maintaining records of all administrative actions.",
  },
};
